import { Component, Input, OnInit } from '@angular/core';
import { TableItem } from '../documents-links/documents-links.component';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
import { catLifeStages, dogLifeStages } from '../life-stages';

@Component({
  selector: 'lib-edit-doc-links',
  templateUrl: './edit-doc-links.component.html',
  styleUrls: ['./edit-doc-links.component.css'],
})
export class EditDocLinksComponent implements OnInit {
  @Input() existingItem: TableItem | null = null;
  @Input() accountId!: string;

  itemType: 'Document' | 'Link' = 'Document';

  // Document fields
  selectedFile: File | null = null;
  name = '';
  docType = 'Adoption';
  species = 'Dog';
  // lifeStage is either a string (when species is "All")
  // or an array (when species is Dog or Cat)
  // lifeStage: string | string[] = '';

  // Link fields
  linkName = '';
  linkUrl = '';
  linkDocType = 'General';
  linkSpecies = '';
  // linkLifeStage: string | string[] = '';

  // Life stage options
  // catLifeStages = catLifeStages;
  // dogLifeStages = dogLifeStages;

  constructor(public activeOffcanvas: NgbActiveOffcanvas) {}

  ngOnInit() {
    if (this.existingItem) {
      if (this.existingItem.blobUrl) {
        this.itemType = 'Document';
        this.name = this.existingItem.name;
        this.docType = this.existingItem.docType || 'Adoption';
        this.species = this.existingItem.species || 'Dog';
        // this.lifeStage = (this.existingItem.lifeStage && this.existingItem.lifeStage !== '')
        //   ? this.existingItem.lifeStage
        //   : '';
      } else {
        this.itemType = 'Link';
        this.linkName = this.existingItem.name;
        this.linkUrl = this.existingItem.url || '';
        this.linkDocType = this.existingItem.docType || 'General';
        this.linkSpecies = this.existingItem.species || '';
        // this.linkLifeStage = (this.existingItem.lifeStage && this.existingItem.lifeStage !== '')
        //   ? this.existingItem.lifeStage
        //   : '';
      }
    }
  }

  onFileSelected(event: any) {
    this.selectedFile = event.target.files?.[0] || null;
  }

  onSubmit(form: NgForm) {
    // Mark all fields as touched so error messages are shown
    form.form.markAllAsTouched();

    // If form is invalid, don't submit
    if (form.invalid) {
      return;
    }

    if (this.itemType === 'Document') {
      if (this.selectedFile) {
        const userData = {
          accountId: this.accountId,
          itemType: 'Document',
          document: {
            file: this.selectedFile,
            name: this.name || this.selectedFile.name,
            docType: this.docType,
            species: this.species,
            // lifeStage: this.lifeStage, 
          },
          link: null,
        };
        this.activeOffcanvas.close(userData);
      } else {
        // If no new file is selected, assume the existing file remains
        if (!this.existingItem || !this.existingItem.blobUrl) {
          alert('Existing file information not available.');
          return;
        }
        const userData = {
          accountId: this.accountId,
          itemType: 'Document',
          document: {
            file: null,
            name: this.name,
            docType: this.docType,
            species: this.species,
            // lifeStage: this.lifeStage, 
            filename: this.existingItem.filename,
            blobUrl: this.existingItem.blobUrl,
            originalFilename: (this.existingItem as any).originalFilename || '',
          },
          link: null,
        };
        this.activeOffcanvas.close(userData);
      }
    } else {
      const userData = {
        accountId: this.accountId,
        itemType: 'Link',
        link: {
          name: this.linkName,
          link: this.linkUrl,
          docType: this.linkDocType,
          species: this.linkSpecies || null,
          // lifeStage: this.linkLifeStage,
        },
        document: null,
      };
      this.activeOffcanvas.close(userData);
    }
  }

  // onSpeciesChange() {
  //   if (this.species === 'All') {
  //     this.lifeStage = 'All';
  //   } else {
  //     this.lifeStage = [];
  //   }
  // }

  // onLinkSpeciesChange() {
  //   if (this.linkSpecies === 'All') {
  //     this.linkLifeStage = 'All';
  //   } else {
  //     this.linkLifeStage = [];
  //   }
  // }

  // Enforce that if the species is Dog or Cat, and the model is an array,
  // selecting the species-specific "All" option should override any other selection.
  // onLifeStageChange() {
  //   if (
  //     (this.species === 'Dog' || this.species === 'Cat') &&
  //     Array.isArray(this.lifeStage)
  //   ) {
  //     const allOption =
  //       this.species === 'Dog' ? 'speciesDogAll' : 'speciesCatAll';
  //     if (this.lifeStage.includes(allOption) && this.lifeStage.length > 1) {
  //       this.lifeStage = [allOption];
  //     }
  //   }
  // }

  // onLinkLifeStageChange() {
  //   if (
  //     (this.linkSpecies === 'Dog' || this.linkSpecies === 'Cat') &&
  //     Array.isArray(this.linkLifeStage)
  //   ) {
  //     const allOption =
  //       this.linkSpecies === 'Dog' ? 'speciesDogAll' : 'speciesCatAll';
  //     if (this.linkLifeStage.includes(allOption) && this.linkLifeStage.length > 1) {
  //       this.linkLifeStage = [allOption];
  //     }
  //   }
  // } 

  onCancel() {
    this.activeOffcanvas.dismiss();
  }
}